import PreventionModel from './Prevention.model';

export default class Preventions {
  constructor({ femme: women, homme: men, indifferent: optionalInfos }) {
    this.optionalInfos = optionalInfos;
    this.mainInfos = women || men;
  }

  hasMainInfos() {
    return !!this.mainInfos;
  }

  hasOptionalInfos() {
    return !!this.optionalInfos;
  }

  getPreventionMustReadTitles({ isOptional = false }) {
    const { a_lire_absolument: mustRead } = this[!isOptional ? 'mainInfos' : 'optionalInfos'];
    return mustRead ? Object.keys(mustRead)?.reverse() : [];
  }

  getPreventionFacultativeTitles({ isOptional = false }) {
    const { a_lire_facultatif: optionalRead } = this[!isOptional ? 'mainInfos' : 'optionalInfos'];
    return optionalRead ? Object.keys(optionalRead)?.reverse() : [];
  }

  getPreventionMustReadContents({ isOptional = false }) {
    const { a_lire_absolument: mustRead } = this[!isOptional ? 'mainInfos' : 'optionalInfos'];
    return mustRead;
  }

  getPreventionFacultativeContents({ isOptional = false }) {
    const { a_lire_facultatif: optionalRead } = this[!isOptional ? 'mainInfos' : 'optionalInfos'];
    return optionalRead;
  }

  getPreventionByTitle({ isOptional = false, isFacultative = false, title }) {
    const values = isFacultative ? this.getPreventionFacultativeContents({ isOptional })
      : this.getPreventionMustReadContents({ isOptional });
    return values && values[title]?.map((val) => new PreventionModel(val));
  }
}
